import { createContext, type Context } from 'react';

import { useRequiredContext } from '@/hooks';
import type { SiteWithApis } from '@/stores';

type AccessibleSitesContextType = {
  /** Every site the signed-in user can reach, each with its resolved API base URLs. */
  sites: SiteWithApis[];
  /** True once the accessible-site list has been fetched. The list may still be empty; this only
   * signals that loading has settled so consumers can distinguish "no sites" from "still loading". */
  areSitesResolved: boolean;
};

export const AccessibleSitesContext: Context<AccessibleSitesContextType | undefined> =
  createContext<AccessibleSitesContextType | undefined>(undefined);

export const useAccessibleSitesContext = (): AccessibleSitesContextType =>
  useRequiredContext({
    context: AccessibleSitesContext,
    hookName: 'useAccessibleSitesContext',
    providerName: 'AccessibleSitesProvider',
  });
